import axios from 'axios';

const coreApi = axios.create({
	baseURL: `//${process.env.VUE_APP_API_HOST}`,
});

export default coreApi;
